import axios from 'axios';
import Api from '../Config';
import i18n from '../i18n'; // initialized i18next instance


export const getGlobals = globals => ({
  type: 'GET_GLOBALS',
  globals,
});

export const updateMeta = meta => ({
  type: 'UPDATE_META',
  meta,
});

export const updateLoader = loader => ({
  type: 'UPDATE_LOADER',
  loader,
});

export const setLang = (lang) => {
  i18n.changeLanguage(lang);
  return {
    type: 'SET_LANG',
    lang,
  };
};

export const setError = error => ({
  type: 'SET_ERROR',
  error,
});

export const isLoading = loading => ({
  type: 'IS_LOADING',
  isLoading: loading,
});

export const fetchGlobals = lang => dispatch => axios.get(`${Api.base + lang}/${Api.globals}`).then((response) => {
  const data = response.data;
  dispatch(getGlobals(data));
}).catch((error) => {
  dispatch(setError(error.response.status.toString()));
});



// WEBPACK FOOTER //
// ./frontend/js/Base/Actions/globalActions.jsx